export default "__VITE_ASSET__0feb7e26__"